module.exports = __webpack_public_path__ + "static/media/42.7c32135f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/42.jpg
// module id = 575
// module chunks = 0